import { type PaletteOptions } from '@mui/material/styles'
import { staticPalette } from '../static'
import { components } from './components'
import { blue } from './dark-blue'
import { dhlRed } from './dark-dhl-red'
import { green } from './dark-green'
import { grey } from './dark-grey'
import { opacity } from './dark-opacity'
import { orange } from './dark-orange'
import { postYellow } from './dark-post-yellow'
import { pure } from './dark-pure'
import { red } from './dark-red'

export const palettePplDark: PaletteOptions = {
  mode: 'dark',
  grey,
  pure,
  static: staticPalette,
  background: {
    default: grey[100],
    paper: grey[200],
    brand: postYellow[500],
  },
  text: {
    primary: grey[800],
    secondary: grey[700],
    tertiary: grey[600],
    disabled: grey[500],
    dhlRed: dhlRed[700],
    error: red[600],
    warning: orange[700],
    success: green[600],
    informative: blue[600],
    inherit: 'inherit',
    placeholder: grey[600],
    icon: 'rgba(255, 255, 255, 0.5)',
  },
  primary: {
    main: dhlRed[600],
    light: dhlRed[200],
    dark: dhlRed[400],
    contrastText: pure.dark,
    states: {
      focus: dhlRed[300],
      hover: opacity.primary[80],
    },
    notContained: dhlRed[700],
  },
  secondary: {
    main: postYellow[600],
    light: postYellow[200],
    dark: postYellow[800],
    contrastText: staticPalette.dark,
    states: {
      focus: postYellow[300],
      hover: postYellow[200],
    },
    notContained: postYellow[800],
  },
  alternative: {
    main: grey[250],
    dark: grey[400],
    light: grey[200],
    // JIRA-#DS-53 remove when old theme is gone, NOT NOW!
    contrast: pure.dark,
    contrastText: pure.dark,
    states: {
      focus: grey[400],
      hover: opacity.dark[250],
    },
  },
  dark: {
    main: grey[800],
    light: grey[300],
    dark: grey[900],
    contrastText: pure.light,
    states: {
      focus: grey[400],
      hover: opacity.dark[80],
    },
    notContained: grey[900],
  },
  light: {
    main: pure.light,
    light: pure.light,
    dark: pure.light,
    contrastText: grey[900],
    states: {
      focus: grey[400],
      hover: opacity.light[80],
    },
    notContained: pure.light,
  },
  info: {
    main: blue[600],
    light: blue[200],
    dark: blue[700],
    contrastText: pure.light,
    states: {
      focus: blue[300],
      hover: blue[200],
    },
    notContained: blue[700],
  },
  success: {
    main: green[600],
    dark: green[800],
    light: green[200],
    contrastText: pure.light,
    states: {
      focus: green[300],
      hover: green[200],
    },
    notContained: green[800],
  },
  warning: {
    main: orange[700],
    dark: orange[900],
    light: orange[200],
    contrastText: pure.light,
    states: {
      focus: orange[400],
      hover: orange[200],
    },
    notContained: orange[900],
  },
  error: {
    main: red[600],
    dark: red[700],
    light: red[200],
    contrastText: pure.light,
    states: {
      focus: red[300],
      hover: red[200],
    },
    notContained: red[700],
  },
  components,

  // START overrule some items already in MUI (so we do not have to do this in components)
  action: {
    disabled: opacity.dark[250],
    disabledBackground: opacity.dark[50],
    disabledOpacity: 1,
    hover: opacity.dark[50],
  },
  divider: grey[300],
  // END overrule some items already in MUI (so we do not have to do this in components)
}
